import { useState } from 'react';
import { faqList } from '@/mocks/faq';

export default function FAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);

  return (
    <section className="py-14 md:py-20 bg-background-100">
      <div className="px-4 md:px-6 max-w-4xl mx-auto">
        <div className="text-center mb-12">
          <h2 className="font-heading text-2xl md:text-4xl font-bold text-foreground-950 mb-4">
            常见<span className="text-accent-500">问题</span>
          </h2>
          <p className="text-foreground-500 text-sm md:text-base max-w-xl mx-auto leading-relaxed">
            关于91爆料网，你想知道的都在这里
          </p>
        </div>

        <div className="flex flex-col gap-3">
          {faqList.map((faq, index) => (
            <div
              key={index}
              className="bg-background-50 border border-background-200/70 rounded-lg overflow-hidden"
            >
              <button
                className="w-full flex items-center justify-between p-5 text-left cursor-pointer hover:bg-background-100 transition-colors duration-200"
                onClick={() => setOpenIndex(openIndex === index ? null : index)}
              >
                <span className="font-heading text-base font-semibold text-foreground-900 pr-4">
                  {faq.question}
                </span>
                <i
                  className={`text-lg text-foreground-400 transition-transform duration-300 flex-shrink-0 ${
                    openIndex === index ? 'ri-subtract-line rotate-180' : 'ri-add-line'
                  }`}
                ></i>
              </button>
              {openIndex === index && (
                <div className="px-5 pb-5">
                  <p className="text-foreground-600 text-sm leading-relaxed">
                    {faq.answer}
                  </p>
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}